import React, { useEffect } from 'react';
import './css/Certifications.css'; // Assuming you have a CSS file for additional styling

// Import certificate images
import awsCertification from './images/aws.png';
import kubernetesCertification from './images/aws.png';
import pythonCertification from './images/aws.png';
import ansibleCertification from './images/aws.png';


const certifications = [
  {
    name: 'AWS Certified Solutions Architect',
    id: 'AWS-123456',
    expiry: '2023-12-31',
    image: awsCertification
  },
  {
    name: 'Certified Kubernetes Administrator',
    id: 'CKA-654321',
    expiry: '2024-06-30',
    image: kubernetesCertification
  },
  {
    name: 'Python Programming Certification',
    id: 'PY-789012',
    expiry: '2025-03-15',
    image: pythonCertification
  },
  {
    name: 'Ansible Automation Certification',
    id: 'ANS-345678',
    expiry: '2024-09-20',
    image: ansibleCertification
  }
];

const Certifications = () => {
  useEffect(() => {
    const elements = document.querySelectorAll('.certification-wrapper');
    elements.forEach((el, index) => {
      el.style.animationDelay = `${index * 0.3}s`;
    });
  }, []);

  return (
    <div className="certifications-container">
      {certifications.map((cert, index) => (
        <div className={`certification-wrapper ${index % 2 === 0 ? 'left' : 'right'}`} key={cert.id}>
          <div className="certification">
            <div className="certification-text">
              <h2>{cert.name}</h2>
              <p><strong>ID:</strong> {cert.id}</p>
              <p><strong>Expiry Date:</strong> {cert.expiry}</p>
            </div>
            <div className="certification-image">
              <img src={cert.image} alt={`${cert.name} Certificate`} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Certifications;